import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import { careersTransitionName } from "@lib/viewTransitions"
import type { CareerItem, SupportedLocale as Lang } from "@site-types/site"
import { AstroTransitionLink } from "../../AstroTransitionLink"
import {
  imageAlt,
  imageDimensions,
  imageSizes,
  imageSrcSet,
  imageTitle,
  imageUrl,
} from "../../componentUtils"
import "./styles.css"

export function CareersCard({
  locale,
  position,
  priority = false,
}: {
  locale: Lang
  position: CareerItem
  priority?: boolean
}) {
  if (!position.newsCoverImage) return null
  const transitionName = careersTransitionName(position.slug?.current ?? "")
  return (
    <li
      className="position"
      data-content-transition-element="true"
      data-content-transition-name={transitionName}
      data-id={`career-card-${position.slug?.current ?? "unknown"}`}
    >
      <AstroTransitionLink
        to={`/${locale}/careers/${position.slug?.current}`}
        className="image"
        aria-label={position.title}
        data-id={`career-card-link-${position.slug?.current ?? "unknown"}`}
        transitionName={transitionName}
      />
      <img
        title={imageTitle(position.newsCoverImage, locale)}
        src={imageUrl(position.newsCoverImage, "careerCard")}
        srcSet={imageSrcSet(position.newsCoverImage, "careerCard")}
        sizes={imageSizes("careerCard")}
        alt={imageAlt(position.newsCoverImage, locale)}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "auto"}
        {...imageDimensions(position.newsCoverImage)}
      />
      <h4>{position.title}</h4>
      <h5 dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(position.teamName) }} />
    </li>
  )
}

export default CareersCard
